import { SettingsService } from 'rainbow-web-sdk/services/core/settings.service';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { Service } from 'rainbow-web-sdk/services/service';
import { MD5 } from '../utilities';

export const USER_INFO_SVC = 'UserInfoService';

export class UserInfoService extends Service {

    public userColors: string[] = ["#c22828", "#ce471d", "#c62582", "#9b4cE7", "#a15e9d", "#7065bd", "#5565f1", "#1b70e0", "#3778b9", "#547d66", "#218500", "#1c6f3c"];
    public userColorNames: string[] = ["purple-lavender", "purple-violet", "red-coral", "blue-jeanlouisdavid", "green-mint", "green-yellow", "orange-jade", "pink-lady", "yellow-submarine", "blue-teal"];

    private logger: LoggerService = LoggerService.getInstance();
    private settingsService: SettingsService = SettingsService.getInstance();

    public static getInstance() {
        return Service.create(USER_INFO_SVC, UserInfoService);
    }

    public static build() {
        return new UserInfoService();
    }

    private constructor() { super(); }

    public getAvatarImage(objId: string, initials: string, color: string, size: number, lastAvatarUpdate: any): HTMLImageElement | { src: string; } | null {
        lastAvatarUpdate = (typeof lastAvatarUpdate === "undefined") ? false : lastAvatarUpdate;
        if (!lastAvatarUpdate) return initials ? this.createDefaultAvatarImage(initials, color) : null;
        const serverURL = config.webservices.protocol + "://" + config.webservices.currentServer;
        let src = serverURL + "/api/avatar/" + objId + "?size=" + (size ? size : 256);
        if (lastAvatarUpdate) { src += "&update=" + MD5(lastAvatarUpdate); }
        return { src };
    }

    public getNameInformation(firstName: string, lastName: string): { displayName: string; initials: string; } {
        const result = { displayName: "", initials: "" };
        if (lastName.length !== 1 && firstName.length !== 2) {
            if (this.settingsService.getSetting("displayOrder") === "FL") {
                result.displayName = firstName + " " + lastName;
                result.initials = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
            }
            else {
                result.displayName = lastName + " " + firstName;
                result.initials = lastName.charAt(0).toUpperCase() + firstName.charAt(0).toUpperCase();
            }
        }
        else {
            if (this.settingsService.getSetting("displayOrder") === "FL") { result.displayName = firstName + " " + lastName; }
            else { result.displayName = lastName + " " + firstName; }
            result.initials = firstName.charAt(0).toUpperCase() + firstName.charAt(1).toUpperCase();
        }
        return result;
    }

    public createDefaultAvatarImage(initials: string, color: string) {
        const image = new Image();
        const canvas = document.createElement("canvas");
        canvas.width = image.width = 225;
        canvas.height = image.height = 225;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            throw new Error("failed to get 2d context");
        }
        ctx.rect(0, 0, 225, 225);
        ctx.fillStyle = color;
        ctx.fill();
        ctx.font = "bold 100px Helvetica";
        ctx.textAlign = "center";
        ctx.fillStyle = "white";
        ctx.fillText(initials, 110, 150);
        image.src = canvas.toDataURL("image/png");
        return image;
    }

    public computeUserColor(displayName: string): { colorIndex: number; color: string; colorName: string; } {
        const result = { colorIndex: 0, color: this.userColors[0], colorName: this.userColorNames[0] };
        try {
            const upperCaseDisplayName = displayName.toUpperCase();
            let sum = 0;
            for (let i = 0; i < upperCaseDisplayName.length; i++) { sum += upperCaseDisplayName.charCodeAt(i); }
            result.colorIndex = (sum % 12);
            result.color = this.userColors[result.colorIndex];
            result.colorName = this.userColorNames[result.colorIndex];
        }
        catch (error) {
            this.logger.error("[UserInfoService] computeUserColor failure");
            result.colorIndex = 1;
            result.color = this.userColors[result.colorIndex];
            result.colorName = this.userColorNames[result.colorIndex];
        }
        return result;
    }
}
